// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bc7ee219","703":"815b6d44"}[chunkId] + ".chunk.js";
};